const getters = {
  loading: state => {
    return state.loading
  },
  searchResult: state => {
    state.searchResult['pageSize'] = state.pageSize
    return state.searchResult
  },
  menuList: state => {
    return state.menuList
  },
  agencyMarginList: state => {
    if (state.agencyMarginList == null) return []
    return state.agencyMarginList.map(agencyMargin => {
      return {
        text: agencyMargin.name + '(' + agencyMargin.marginValue + '%)',
        value: agencyMargin.id,
        isDefault: agencyMargin.isDefault,
      }
    })
  },
  salesAccountList: state => {
    return state.salesAccountList
  },
  permissionLevel: (state, getters, rootState) => {
    const pagePermission = rootState.pagePermission.permissionLevel
    switch (pagePermission) {
      case 'admin':
      case 'operator': {
        return 'edit'
      }
      case 'readonly':
      case 'view': {
        return 'view'
      }
      default: {
        return 'none'
      }
    }
  },
  inventoryLists: state => {
    return state.inventoryLists
  },
  keyword: state => {
    return state.keyword
  },
  advertiserId: state => {
    return state.advertiserId
  },
  pageNo: state => {
    return state.pageNo
  },
  ioStatuses: state => {
    return state.ioStatuses
  },
  sortOptions: state => {
    return state.sortOptions
  },
}

export default getters
